// extracted by mini-css-extract-plugin
module.exports = {"content":"UserTypeStep_content__1iHoB","typeButton":"UserTypeStep_typeButton__2kt3z","icon":"UserTypeStep_icon__3zWGU"};